import { styled } from '@abyss/web/tools/styled';
import { Markdown } from '@abyss/web/ui/Markdown';
import { Modal } from '@abyss/web/ui/Modal';
import find from 'lodash/find';
import React, { forwardRef } from 'react';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useLagoon } from '../../hooks/useLagoon';
import { usePreventScrollPropagation } from '../Utils/a11yUtils/a11yUtils';

export const ModalContent = styled(Markdown, {
  fontSize: '14px',
  lineHeight: '18px',
  maxHeight: '797px',
  color: '#323334',
  '& span': {
    color: '#323334 !important',
  },
});

export const ModalContainer = styled(Modal, {
  '.abyss-modal-content-container': {
    width: 'auto',
    height: 'auto',
    maxWidth: '572px',
  },
  '.abyss-modal-content-title': {
    lineHeight: '40px',
    fontSize: '32.43px',
    fontWeight: '600',
    '@screen < $sm': {
      lineHeight: '36px',
      fontSize: '28.83px',
      fontWeight: '600',
    },
  },
});

interface CulturalCompetencyTrainingProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

export const CulturalCompetencyTraining = forwardRef(
  ({ isOpen, setIsOpen }: CulturalCompetencyTrainingProps, ref) => {
    const data = useLagoon('ui-messaging')();
    const culturalCompetencyModalContent = find(data, {
      key: ConstantsLagoon.CONTENT_FILTERS
        .CULTURAL_COMPETENCY_TOOLTIP_INFO_ICON,
    });

    usePreventScrollPropagation(isOpen);

    return (
      <React.Fragment>
        <ModalContainer
          data-testid="cultural-competency-modal"
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          ref={ref}
          scrollableFocus={true}
          tabIndex={-1}
          title={culturalCompetencyModalContent?.title}
        >
          <Modal.Section>
            <ModalContent>
              {culturalCompetencyModalContent?.message}
            </ModalContent>
          </Modal.Section>
        </ModalContainer>
      </React.Fragment>
    );
  }
);
